import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig } from '../../../app.settings';

@Injectable()
export class WallManagementService {

  public identifyButtonChanged: Subject<boolean> = new Subject();
  public currentAppName: BehaviorSubject<string> = new BehaviorSubject(null);
  public isTurnScreensIdentification: Subject<boolean> = new Subject();
  private endpoint: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig
  ) {
    this.endpoint = `${this.config.getConfig('api')}walls/wall-management/`;
  }

  turnOnScreensIdentification(physicalAddress: string): Observable<void> {
    this.isTurnScreensIdentification.next(true);
    return this.http.post<void>(`${this.endpoint}identify-on/${physicalAddress}`, {}).pipe(
      map(() => {
        this.identifyButtonChanged.next(true);
      })
    );
  }

  turnOffScreensIdentification(physicalAddress: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}identify-off/${physicalAddress}`, {}).pipe(
      map(() => {
        this.identifyButtonChanged.next(false);
      })
    );
  }

  restartClientWithAdministratorRights(physicalAddress: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}restart-client/${physicalAddress}`, {});
  }

  startWallsApplicationNameRecognition(physicalAddress: string): Observable<void> {
    return this.http.get<void>(`${this.endpoint}recognize-desktop-rights/${physicalAddress}`);
  }

  startDesktopClientReadyToUsageValidation(physicalAddress: string): Observable<void> {
    return this.http.get<void>(`${this.endpoint}desktop-ready-to-usage-validation/${physicalAddress}`);
  }

  resetWall(physicalAddress: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}reset/${physicalAddress}`, null);
  }
}
